module.exports = "/lucky-balls/img/combos-sr/201-.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/combos-sr/201-.png
// module id = 984
// module chunks = 0